var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "M201.72,60.42V45h15V0h-165V45h15V60.42c0,28.91,23,48.7,42,67.58-18.79,18.7-42,38.56-42,67.58V211h-15v45h165V211h-15V195.58c0-28.91-23-48.7-42-67.58C178.53,109.3,201.72,89.44,201.72,60.42ZM66.72,15h135V30h-135Zm15,45.42V45h105V60.42a39.61,39.61,0,0,1-3.08,15.08H84.8A39.8,39.8,0,0,1,81.72,60.42ZM201.72,241h-135V226h135ZM146.05,120.5H146L138.43,128,146,135.5h.06c17.87,18.24,40.67,36.29,40.67,60.08V211h-105V195.58c0-23.11,21.61-41,38.85-58.23l.18-.18,1.65-1.67h0L130,128l-7.54-7.45h0l-2.16-2.18L114.82,113c-7.52-7.36-15-14.63-21.07-22.47H174.7C166.61,101,155.88,110.46,146.05,120.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHourglass);
export default __webpack_public_path__ + "static/media/icon-hourglass.66857379.svg";
export { ForwardRef as ReactComponent };